import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

import { GestionErreurService } from '../../services/gestion-erreur.service';
import { AppConfigService } from '../../../app-config.service';
import { TracingSpaApiService } from '../../../shared/services/tracing-spa-api.service';

@Component({
  selector: 'app-erreur',
  templateUrl: './erreur.component.html',
  styleUrls: ['./erreur.component.scss'],
  standalone: false
})
export class ErreurComponent implements OnInit {
  erreurHTTP = new BehaviorSubject<number>(null);
  erreurHTTPSubscription: Subscription;

  private urlRetour: string;

  isConfigLoaded: boolean;
  isPDOFusionPending: boolean;

  constructor(
    private readonly _gestionErreurService: GestionErreurService,
    private readonly _appConfigService: AppConfigService,
    tracingSpaApiService: TracingSpaApiService
  ) {
    this.erreurHTTPSubscription = this._gestionErreurService.erreurHTTPReturnedChanged$.subscribe(httpError => {
      tracingSpaApiService.postLogPageErreurSpa(httpError);
      if (this.erreurHTTPSubscription) {
        this.erreurHTTPSubscription.unsubscribe();
        this.erreurHTTPSubscription = null;
      }
    });
  }

  ngOnInit() {
    this.isConfigLoaded = this._appConfigService.isConfigLoaded;
    this.isPDOFusionPending = this._appConfigService.isPDOFusionPending;
    this.urlRetour = this._appConfigService.urlRetour;
  }

  retourAccueil(): void {
    window.location.href = this.urlRetour;
  }
}
